import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useContent } from "../lib/content";

const PHOTO =
  "https://customer-assets.emergentagent.com/job_inner-pulse-1/artifacts/mdjdlid4_Inner%20Pulse%203.JPG";

export default function Sets() {
  const kicker = useContent("page.sets.kicker", "/ 03 — SETS");
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(true);
  const title = useContent("page.sets.title", "RECORDED SESSIONS");
  const intro = useContent(
    "page.sets.intro",
    "Hand-picked recordings. Hypnotic techno, tribal textures and hardgroove — long-form rituals captured in full."
  );
  const footerNote = useContent(
    "page.sets.footer_note",
    "More sessions available on SoundCloud & Linktree."
  );

  useEffect(() => {
    api
      .get("/sets")
      .then((r) => setSets(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="sets-page" className="px-6 md:px-12 py-20">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-10 mb-16 items-end" data-testid="sets-header">
          <div className="md:col-span-7 flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <span className="w-8 h-px bg-silver-400" />
              <span className="font-title text-[0.65rem] tracking-[0.4em] text-silver-400">
                {kicker}
              </span>
            </div>
            <h1 className="font-title text-silver-glow text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-[0.06em] whitespace-pre-line">
              {title}
            </h1>
            <p className="font-body text-silver-400 text-sm md:text-base max-w-xl leading-relaxed">
              {intro}
            </p>
          </div>
          <div className="md:col-span-5">
            <div className="aspect-[4/5] hairline overflow-hidden" data-testid="sets-photo">
              <img
                src={PHOTO}
                alt=""
                className="w-full h-full object-cover"
                style={{ filter: "grayscale(90%) contrast(1.1) brightness(0.95)" }}
              />
            </div>
          </div>
        </div>

        {loading && (
          <p className="font-body text-silver-500 text-sm" data-testid="sets-loading">
            Loading sessions…
          </p>
        )}

        {!loading && sets.length === 0 && (
          <p className="font-body text-silver-500 text-sm py-10" data-testid="sets-empty">
            No sessions yet.
          </p>
        )}

        <div className="flex flex-col gap-12" data-testid="sets-list">
          {sets.map((s, i) => (
            <article
              key={s.id}
              className="hairline-t pt-10 grid md:grid-cols-12 gap-6"
              data-testid={`set-card-${s.id}`}
            >
              <div className="md:col-span-3 flex flex-col gap-3">
                <div className="font-title text-[0.6rem] tracking-[0.3em] text-silver-600">
                  / {String(i + 1).padStart(2, "0")}
                </div>
                {s.genre && (
                  <div className="font-title text-[0.62rem] tracking-[0.3em] text-silver-100 hairline self-start px-2 py-1 uppercase">
                    {s.genre}
                  </div>
                )}
                <h2 className="font-title text-xl md:text-2xl tracking-[0.1em] text-silver-100 leading-tight">
                  {s.title}
                </h2>
                <div className="flex gap-2 flex-wrap mt-1">
                  {s.year && (
                    <span className="font-title text-[0.58rem] tracking-[0.3em] text-silver-500 hairline px-2 py-1">
                      {s.year}
                    </span>
                  )}
                  {s.location && (
                    <span className="font-title text-[0.58rem] tracking-[0.3em] text-silver-500 hairline px-2 py-1">
                      {s.location}
                    </span>
                  )}
                </div>
                {s.notes && (
                  <p className="font-body text-xs text-silver-500 mt-1 leading-relaxed">
                    {s.notes}
                  </p>
                )}
              </div>
              <div className="md:col-span-9">
                <iframe
                  title={s.title}
                  width="100%"
                  height="180"
                  scrolling="no"
                  frameBorder="no"
                  allow="autoplay"
                  src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(
                    s.url
                  )}&color=%23c6c6c6&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=false`}
                />
              </div>
            </article>
          ))}
        </div>

        <div
          className="mt-20 hairline-t pt-10 flex justify-between items-center flex-wrap gap-4"
          data-testid="sets-footer"
        >
          <p className="font-body text-silver-500 text-xs">
            {footerNote}
          </p>
          <a
            href="https://linktr.ee/sandravidalsoundation"
            target="_blank"
            rel="noreferrer"
            className="btn-ghost"
            data-testid="sets-external-link"
          >
            OPEN LINKTREE →
          </a>
        </div>
      </div>
    </div>
  );
}
